import React from 'react'
import { sortByProductOrder } from '../../../../../helper'
import PAID_LEAVE from '../../../../../constants'

const PaidLeaveTypes = (props) => {
  const sortedProducts = sortByProductOrder(props.products)
  return (
    <div>
      {Object.keys(props.products).length > 0 ? (
        sortedProducts.map((productKey) => (
          <p data-testid="pl-notifications-product" key={productKey}>
            {PAID_LEAVE.PRODUCTS.find((p) => p.id === productKey).name}
          </p>
        ))
      ) : (
        <p data-testid="pl-notifications-no-product">N/A for this Location</p>
      )}
    </div>
  )
}

export default PaidLeaveTypes
